import React from "react";

export const JesusGod = ({size = 20, ...props}) => {
	return (
		<svg
			height={size}
			viewBox="0 0 64 64"
			width={size}
			xmlns="http://www.w3.org/2000/svg"
			{...props}>
			<g data-name="Layer 32">
				<path
					d="M54.993 46.468A20.393 20.393 0 0050.7 34.475a16.423 16.423 0 01-3.3-7.835l-2.09-15.146A11 11 0 0034.417 2 3.421 3.421 0 0032 3a3.421 3.421 0 00-2.417-1 11 11 0 00-10.892 9.494L16.6 26.64a16.423 16.423 0 01-3.3 7.835 20.4 20.4 0 00-4.293 11.986z"
					fill="#916658"
				/>
				<path
					d="M54.993 46.468A20.39 20.39 0 0050.7 34.475a16.415 16.415 0 01-3.3-7.834l-2.09-15.146A11 11 0 0034.417 2 3.421 3.421 0 0032 3a3.4 3.4 0 00-1.693-.917 10.99 10.99 0 00-9.616 9.411L18.6 26.64a16.415 16.415 0 01-3.3 7.834 20.4 20.4 0 00-4.291 11.986z"
					fill="#a37765"
				/>
				<path
					d="M59 63l-.769-10a9.766 9.766 0 00-2.111-5.35 9.76 9.76 0 00-5.427-3.413L43.9 42.67a6.321 6.321 0 01-4.235-3.335A6.323 6.323 0 0139 36.507v-2.185H25v2.185a6.323 6.323 0 01-.668 2.828A6.321 6.321 0 0120.1 42.67l-6.79 1.567a9.76 9.76 0 00-5.43 3.413A9.766 9.766 0 005.769 53L5 63z"
					fill="#d08d78"
				/>
				<path
					d="M56.12 47.65a9.76 9.76 0 00-5.427-3.413L43.9 42.67a6.327 6.327 0 01-4.9-6.163V35.3a11.019 11.019 0 01-7 4.7 11.022 11.022 0 01-5.086-2.516A6.276 6.276 0 0122.1 42.67l-6.79 1.567A9.762 9.762 0 007.769 53L7 63h52l-.769-10a9.766 9.766 0 00-2.111-5.35z"
					fill="#f2b9a1"
				/>
				<path
					d="M58.231 53a9.762 9.762 0 00-7.538-8.763L43.9 42.67c-.049-.011-.095-.029-.144-.042l-.006.005a18 18 0 01-23.506 0v-.005c-.049.012-.1.031-.145.042l-6.79 1.567A9.762 9.762 0 005.769 53L5 63h54z"
					fill="#d7e0ef"
				/>
				<path
					d="M56.12 47.65a9.76 9.76 0 00-5.427-3.413L43.9 42.67c-.049-.011-.095-.029-.144-.042l-.006.005a17.966 17.966 0 01-23.052.359l-5.394 1.245A9.762 9.762 0 007.769 53L7 63h52l-.769-10a9.766 9.766 0 00-2.111-5.35z"
					fill="#f0f6ff"
				/>
				<path
					d="M32 7l.67 1.172A22.167 22.167 0 0042 17v6.805a20.042 20.042 0 01-2.523 9.736A11.031 11.031 0 0132 39a11.026 11.026 0 01-7.476-5.457A20.059 20.059 0 0122 23.8V17a22.159 22.159 0 009.328-8.824z"
					fill="#d08d78"
				/>
				<path
					d="M33 8.7a22.147 22.147 0 01-9 8.3v6.8a20.061 20.061 0 002.524 9.74A11.015 11.015 0 0033 38.742a11.019 11.019 0 006.477-5.2A20.042 20.042 0 0042 23.805V17a22.166 22.166 0 01-9-8.3z"
					fill="#f2b9a1"
				/>
				<path
					d="M48.368 43.7a22 22 0 01-32.736 0l4.615-1.067a18 18 0 0023.506 0z"
					fill="#d7e0ef"
				/>
				<path
					d="M35.713 32.465a2.675 2.675 0 01-3.5-.249L32 32l-.216.216a2.675 2.675 0 01-3.5.249A13.149 13.149 0 0123.7 26.1L22 21v2.8a20.061 20.061 0 002.524 9.74A11.026 11.026 0 0032 39a11.031 11.031 0 007.477-5.459A20.042 20.042 0 0042 23.805V21l-1.7 5.1a13.149 13.149 0 01-4.587 6.365z"
					fill="#5b5b5b"
				/>
				<path
					d="M35.713 32.465a2.675 2.675 0 01-3.5-.249L32 32l-.216.216a2.675 2.675 0 01-3.5.249 13.152 13.152 0 01-3.876-4.665 20.073 20.073 0 002.116 5.741A11.015 11.015 0 0033 38.742a11.019 11.019 0 006.477-5.2A20.042 20.042 0 0042 23.805V21l-1.7 5.1a13.149 13.149 0 01-4.587 6.365z"
					fill="#7a7a7a"
				/>
				<path
					d="M58.231 53a9.762 9.762 0 00-7.538-8.763l-.068-.016L39 63h20z"
					fill="#ff959d"
				/>
				<path d="M35 56h-2v-2h-2v2h-2v2h2v5h2v-5h2z" fill="#5b5b5b" />
				<path
					d="M17 63h-2v-4.838l-.948-2.846 1.9-.632 1 3A1 1 0 0117 58z"
					fill="#d7e0ef"
				/>
				<path
					d="M49 63h-2v-5a1 1 0 01.052-.316l1-3 1.9.632L49 58.162z"
					fill="#ff7a7e"
				/>
			</g>
		</svg>
	);
}

export default JesusGod;
